const styles = {
  dialogPaper: {
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    minWidth: '400px',
    maxWidth: '600px',
  },
  dialogTitle: {
    padding: '24px 24px 0 24px',
    borderBottom: '1px solid #e0e0e0',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  title: {
    fontWeight: 600,
    color: '#1a1a1a',
    flex: 1,
  },
  closeButton: {
    color: '#666',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  dialogContent: {
    padding: '24px',
    '&.MuiDialogContent-root': {
      paddingTop: '16px',
    },
  },
  message: {
    color: '#333',
    lineHeight: 1.6,
    fontSize: '16px',
    whiteSpace: 'pre-line',
  },
  dialogActions: {
    padding: '0 24px 24px 24px',
    justifyContent: 'center',
  },
  confirmButton: {
    minWidth: '120px',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
  },
};

export default styles;
